import { Box, Flex, HStack } from '@skin-seoul/design-system';
import { Skeleton } from '@skin-seoul/design-system';
import type { ComponentProps } from 'react';
import React from 'react';
type VerticalProductCardSkeletonProps = ComponentProps<typeof Flex>;
export const VerticalProductCardSkeleton = ({
  ...props
}: VerticalProductCardSkeletonProps) => {
  return <Flex direction="column" gap={4} width="100%" cursor="pointer" minWidth={0} {...props} data-sentry-element="Flex" data-sentry-component="VerticalProductCardSkeleton" data-sentry-source-file="VerticalProductCard.Skeleton.tsx">
      <Skeleton borderRadius="8px" overflow="hidden" height={{
      base: '200px',
      tablet: '300px'
    }} width="100%" minWidth={0} position="relative" data-sentry-element="Skeleton" data-sentry-source-file="VerticalProductCard.Skeleton.tsx" />

      <Box display="flex" flexDirection="column" gap={3} width="100%" minWidth={0} borderRadius="0 0 8px 8px" data-sentry-element="Box" data-sentry-source-file="VerticalProductCard.Skeleton.tsx">
        <Box display="flex" flexDirection="column" gap={2} width="100%" minWidth={0} data-sentry-element="Box" data-sentry-source-file="VerticalProductCard.Skeleton.tsx">
          <Skeleton borderRadius="4px" height="16px" width="120px" data-sentry-element="Skeleton" data-sentry-source-file="VerticalProductCard.Skeleton.tsx" />
          <Skeleton borderRadius="4px" height="16px" width="100%" data-sentry-element="Skeleton" data-sentry-source-file="VerticalProductCard.Skeleton.tsx" />
        </Box>

        <HStack alignItems="center" gap={2} data-sentry-element="HStack" data-sentry-source-file="VerticalProductCard.Skeleton.tsx">
          <Skeleton borderRadius="4px" height="20px" width="80px" data-sentry-element="Skeleton" data-sentry-source-file="VerticalProductCard.Skeleton.tsx" />
          <Skeleton borderRadius="4px" height="20px" width="40px" data-sentry-element="Skeleton" data-sentry-source-file="VerticalProductCard.Skeleton.tsx" />
        </HStack>

        <Box display="flex" alignItems="center" gap={2} data-sentry-element="Box" data-sentry-source-file="VerticalProductCard.Skeleton.tsx">
          <Skeleton borderRadius="4px" height="16px" width="60px" data-sentry-element="Skeleton" data-sentry-source-file="VerticalProductCard.Skeleton.tsx" />
        </Box>
      </Box>
    </Flex>;
};